import { Types } from '../actions/config'

const initialState = {
    configs: [],
}

const formatConfig = (payload) => {
    const formattedConfig = []
    for (let i = 0; i < payload.length; i += 1) {
        try {
            const json = JSON.parse(payload[i].value)
            const config = payload[i]
            config.value = json
            formattedConfig.push(config)
        } catch (e) {
            console.error(e.message)
        }
    }
    return formattedConfig
}

export default (state = initialState, { type, payload = {} }) => {
    switch (type) {
        case Types.CONFIGS_FETCH_SUCCESS:
            const formattedConfig = formatConfig(payload)
            return {
                ...state,
                configs: formattedConfig,
            }
        default:
            return state
    }
}
